import { Locale } from 'modules/i18n';

export const totalTrafficCardTranslation = {
  [Locale.en]: {
    title: 'Total traffic',
    tooltips: {
      hour: 'Your traffic for the last 1 hour',
      day: 'Your traffic for the last 24 hours',
      week: 'Your traffic for the last 7 days',
      month: 'Your traffic for the last 30 days',
    },
  },
};
